import { render } from "./dappIndex.vue?vue&type=template&id=761ef58c"
import script from "./dappIndex.vue?vue&type=script&lang=js"
export * from "./dappIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__